import { Button } from "@/shared/widgets/button";
import { useState } from "react";

interface ConsentViewProps {
  onSubmit: () => void;
  isLoading: boolean;
  isError: boolean;
}

export default function ConsentView({ onSubmit, isLoading, isError }: ConsentViewProps) {
    const [isAgreed, setIsAgreed] = useState<boolean>(false);

  return (
    <div className="flex flex-col flex-1 w-full animate-in zoom-in-95 duration-500 font-['Mulish']">
      <div className="flex-1 flex flex-col items-center justify-center gap-11 w-full mb-8">
        <div className="bg-white rounded-2xl flex flex-col gap-3 justify-center border border-[#E2E8F0] shadow-[0px_4px_4px_0px_#0000001A] w-full p-6 text-center">
          <span className="text-lg font-semibold tracking-wide">Verification Consent</span>
          <span className="text-[#8A8989] leading-[1.5] tracking-wider text-sm text-left">To ensure secure in-store pickup, we perform a quick identity match before handover</span>
          <div className="bg-[#3385FF0F] text-[#0052CC] text-left p-2 rounded-lg w-full text-sm leading-relaxed mt-2">
            <p className="mb-3 font-semibold">By clicking "I Agree," you authorize us to:</p>

            <ul className="list-disc pl-5 mb-4 space-y-3 marker:text-[#0052CC]">
              <li className="pl-1">
                Match a live photo with your Aadhaar Photo from DigiLocker.
              </li>
              <li className="pl-1">
                Securely store this verification data (Masked Aadhaar details, Contact and Aadhaar photo) via our partner, Signzy, for 60 days.
              </li>
            </ul>
            <p>
              As per our policy, verification records are kept for a limited window after pickup to help resolve any future disputes or claims.
            </p>
          </div>
          <label className="flex items-center gap-2 text-[#0052CC] font-bold justify-start text-sm">
            <input type="checkbox" checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} className="w-4 h-4 accent-[#0052CC]" />
            I Agree and Verify
          </label>
          {isError && (
            <span className="text-red-600 text-xs text-left font-medium">
              Failed to submit consent. Please check your connection and try again.
            </span>
          )}
          <Button className="bg-[#021B55] text-md py-3 rounded-xl flex-1 w-full" onClick={onSubmit} disabled={!isAgreed || isLoading}>
            {isLoading ? "Processing..." : "Proceed"}
          </Button>
        </div>
      </div>
    </div>
    );
}